import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params, RouterLink} from '@angular/router';
import { OrganizationService } from '../../shared/services/organization.service';
import { MatSnackBar } from '@angular/material';
import { AuthService } from '../../shared/services//auth/auth.service';
import { forEach } from '@angular/router/src/utils/collection';
import { MatDialog} from '@angular/material';
import { DeletePopupComponent } from '../Popups/delete-popup/delete-popup.component';
import {NgForm, FormBuilder, FormGroup, FormControl} from '@angular/forms';
import { NotificationService } from '../../shared/services/notification.service';
import { ToastService } from '../../shared/services/toast.service';
import { StaticValueService } from '../../shared/services/static-value.service';
import {Location} from '@angular/common';
import { Configuration } from '../../app.constants';
import {Sort} from '@angular/material';


@Component({
  selector: 'app-team-profile',
  templateUrl: './team-profile.component.html',
  styleUrls: ['./team-profile.component.css']
})
export class TeamProfileComponent implements OnInit {

  @ViewChild('myForm')
  public myForm: NgForm ;
  public originalTeamLeaderId: string;
  public organizationId: string;

  public showTeamLeader: Boolean = true;
  // variables for ACL
  public isAdminOrLeader: Boolean = false;
  public isAssociate: Boolean = false;
  public currentUserId: string;
  public serverApiUrl;

  public team: any;
  public teamLeader = [];
  public associateSearch: string;
  public autoCompleteAssociate: any;
  public autoCompleteAssociateOriginal: any;
  public selectedAssociates = [];
  public originalAssociates= [];
  public teams: any;
  public archiveIncludedTeams = [];
  public teamId: string;
  public organization: any;
  public errors: any;
  // Objects for individual cards
  public teamDetail: any;
  public members: any;
  // Booleans for card Edit
  public teamDetailEdit: Boolean = false;
  public membersEdit: Boolean = false;
  public startMemberIndex= 0 ;


  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public organizationService: OrganizationService,
    public snackBar: MatSnackBar,
    public authService: AuthService,
    public dialog: MatDialog,
    public notificationService: NotificationService,
    public toastService: ToastService,
    public staticDDlistService: StaticValueService,
    public _location: Location,
    public config: Configuration
  ) { }

  componentInitTasks() {
    this.archiveIncludedTeams = this.organization.teams;
    this.teams = this.organization.teams.filter(team => {
      if (team.active === true) {
        return team;
      }
    }); // need this for the "parent team" drop down
    this.team = this.archiveIncludedTeams.filter(team => team._id === this.teamId )[0];
    this.teams = this.teams.filter(tm => {
      if (tm._id !== this.team._id) {
        if (tm.teamDetail.parentTeam.teamId  !== this.team._id) {
          return tm;
        }
      }
    });

    // while() {

    // }
    this.autoCompleteAssociateOriginal = Object.assign([], this.organization.associates);
    this.autoCompleteAssociateOriginal = this.autoCompleteAssociateOriginal.filter( assc => assc.active !== false);
    let tempLeaderArray = [];
    tempLeaderArray = this.autoCompleteAssociateOriginal.filter( assc => assc.associateId === this.team.teamDetail.teamLeader.id);
    if (tempLeaderArray.length > 0) {
      this.teamLeader = tempLeaderArray[0];
      this.showTeamLeader = true;
    } else {
      this.showTeamLeader = false;
    }
    console.log('Team ', this.team);
    // cards
    this.teamDetail = Object.assign({}, this.team.teamDetail);
    this.originalTeamLeaderId = this.teamDetail.teamLeader.id;
    this.members = Object.assign({}, this.team.members);
    this.members.associates = Object.assign([], this.team.members.associates);
  }

  ngOnInit() {
    this.serverApiUrl = this.config.StaticImageUrl;
    this.currentUserId = this.authService.user.associateId;
    this.staticDDlistService.getErrors().then(data => { this.errors = data});
    this.organization = JSON.parse(JSON.stringify(this.route.snapshot.data['organization']['data'][0]));
     this.route.params.subscribe(params => {
      this.teamId = params['id'];
      this.organizationId = params['organization_id'];
      this.organizationService.getOrganization(this.organizationId).subscribe((data) => {
        this.organization = JSON.parse(JSON.stringify(data['data'][0]));
        this.componentInitTasks();
        this.selectedAssociates = [];
        this.organization.associates.forEach(assc => {
          this.team.members.associates.forEach(asscId => {
            if (assc.associateId === asscId.id) {
              this.selectedAssociates.push(assc);
            }
          });
        });
        this.originalAssociates = Object.assign([] , this.selectedAssociates);
        // associates
      this.autoCompleteAssociate = Object.assign([], this.organization.associates);
      console.log('Team LEader', this.team.teamDetail.teamLeader.id); },
       (error) => {});
    });
    // get organization and filter the relevant team
    if ((this.authService.user.role === 'Admin') || (this.currentUserId === this.organization.companyLeaderShip.hrLeader.id) ||
    (this.currentUserId === this.organization.companyLeaderShip.companyLeader.id)  ||
    (this.organization.companyLeaderShip.hrTeamIds.indexOf(this.currentUserId) > -1)) {
      this.isAdminOrLeader = true;
      this.isAssociate = false;
    } else {
      this.isAdminOrLeader = false;
      this.isAssociate = true;
    }
    // -------------------------
    this.componentInitTasks();
  }

  associateTyped() {
    this.autoCompleteAssociate = this.autoCompleteAssociateOriginal.filter(
      singleItem => singleItem['name'].toLowerCase().includes(this.associateSearch.toLowerCase()));
  }
  clickDropDown(recievedAssociate: any, obj: string, index: number) {
    if (obj === 'associates' ) {
      if (this.selectedAssociates.length >= this.team.teamDetail.size) {
        this.snackBar.open('Increase team capacity to add other associates', '', {
          duration: 3000
        });
    } else {
      let associateExists = [];
      associateExists  = this.selectedAssociates.filter(assc => {
        if (assc.associateId === recievedAssociate.associateId ) {
          return assc;
        }
      });
      if (associateExists.length > 0) {
        this.snackBar.open('Associate already exists in this team', '', {
          duration: 3000
        });
      } else {
        const associate = {
          'name': recievedAssociate.name,
          'associateId': recievedAssociate.associateId,
          'groupId': recievedAssociate.groupId,
          'avatarUrl': recievedAssociate.avatarUrl,
          'email': recievedAssociate.email
        }
        this.selectedAssociates.push(associate) ;
        // this.autoCompleteAssociate.splice(index, 1);
    }
    }
    }
  }

  edit(cardName: string, editVariable: string, value: Boolean) {
    this[editVariable] = value;
    if (!value) {
      console.log(cardName);
      if (cardName === 'members') {
        this[cardName] = JSON.parse( JSON.stringify(this.team[cardName]));
        this.selectedAssociates = JSON.parse( JSON.stringify(this.team[cardName].associates));
        console.log(this.team[cardName],this.selectedAssociates)
        console.log('Card Objects', this[cardName], 'Team Object', this.team  );
      } else {
        this[cardName] = JSON.parse( JSON.stringify(this.team[cardName]));
      }
    }
  }
  save(cardObj: string, editVariable: string) {
    if (this.teamDetail.size >= this.selectedAssociates.length) {
      let leader = [];
      leader = this.selectedAssociates.filter(assc => {
        if (assc.associateId === this.teamDetail.teamLeader.id) {
          return assc;
        }
      });
      if ( cardObj === 'teamDetail') {
          let parentTeam: any;
          parentTeam = this.teams.filter(team => team._id === this[cardObj].parentTeam.teamId);
          if ( parentTeam.length !== 0 ) {
            this[cardObj].parentTeam.name = parentTeam[0].teamDetail.name;
          }  if ( parentTeam.length === 0 ) {
            this[cardObj].parentTeam.name = '';
            this[cardObj].parentTeam.teamId = '';
          }
      } else if (cardObj === 'members') {
        let tempArr = [];
        this.selectedAssociates.forEach(element => {
          let tempObj = {'id': element.associateId}
          tempArr.push(tempObj);
        });
        this[cardObj].associates = Object.assign([], tempArr);
      }
      // save info of the user that made the changes
      this[cardObj].lastEditedBy.name = this.authService.user.isProxyUser ? this.authService.user.name + ` (${this.authService.user.proxyUser.fullName})` : this.authService.user.name;
      this[cardObj].lastEditedBy.id = this.authService.user.associateId;
      this[cardObj].lastEditedBy.time = new Date();
      // save the team card object
      this.team[cardObj] = JSON.parse(JSON.stringify(this[cardObj]));
      this.team.lastEdited.push(this[cardObj].lastEditedBy);
      if ( cardObj === 'teamDetail') {
        this.teamLeader = this.selectedAssociates.filter( assc => assc.associateId === this.team[cardObj].teamLeader.id)[0];
      }
      if ( leader.length === 0 ) {
        this.teamDetail.teamLeader.id = '';
        this.team.teamDetail.teamLeader.id = '';
        // this.teamLeader = JSON.parse(JSON.stringify({}));
        this.showTeamLeader = false;
      } else {
        this.showTeamLeader = true;
      }
      this.update();
    } else {
      this[cardObj] = JSON.parse(JSON.stringify(this.team[cardObj]));
      this.snackBar.open('Team capacity reached', '', {
        duration: 3000
      });
    }
    this[editVariable] = false;
  }
  // Open delete pop Up
  openDialog(field: string): void {
    const dialogRef = this.dialog.open( DeletePopupComponent, {
      width: '350px',
      data: {name : 'Team'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Cancel') {} else if (result === 'Proceed') {
        if (field === 'archive') {
        this.markAsInactive();
        } else if (field === 'unArchive') {
          this.unArchive();
        }
      }
    });
  }

  markAsInactive() {
    if (this.team.members.associates.length > 0) {
      this.snackBar.open('Remove or re-assign all associates to archive team', '', {
        duration: 3000
      });
  } else {
    this.team.active = false;
    let childTeams = [];
    childTeams = this.teams.filter(team => {
      if (team.teamDetail.parentTeam.teamId  === this.team._id) {
        team.teamDetail.parentTeam.teamId = this.team.teamDetail.parentTeam.teamId;
        team.teamDetail.parentTeam.name = this.team.teamDetail.parentTeam.name;
        return team;
      }
    });
    this.team['lastArchivedBy'] = Object.assign({}, {'name': this.authService.user.isProxyUser ? this.authService.user.name + ` (${this.authService.user.proxyUser.fullName})` : this.authService.user.name,
    'id': this.authService.user.id, 'time': new Date() });
    this.team['lastArchived'].push({'name': this.authService.user.isProxyUser ? this.authService.user.name + ` (${this.authService.user.proxyUser.fullName})` : this.authService.user.name,
    'id': this.authService.user.id, 'time': new Date() });
    this.organizationService.updateTeam(this.organization._id, this.teamId, this.team, this.originalAssociates).subscribe((data) => {
      this.organizationService.updateTeamParents(this.organization._id, childTeams).subscribe((data1) => {
      }, ( error ) => {});
      this.router.navigate([`/home/organization/profile/view/${this.organization._id}/teams`]);
      this.snackBar.open('Team Archived.', '', {
        duration: 3000
      });
      this.originalAssociates = Object.assign([], this.selectedAssociates);
    } , ( error ) => {
      this.snackBar.open('Team could not be Archived.', '', {
        duration: 3000
      });
    });
  }
}
 unArchive() {
   this.team.active = true;
  this.organizationService.updateTeam(this.organization._id, this.teamId, this.team, this.originalAssociates).subscribe((data) => {
    this.router.navigate([`/home/organization/profile/view/${this.organization._id}/teams`]);
    this.snackBar.open('Team Un-Archived', '', {
      duration: 3000
    });
    this.originalAssociates = Object.assign([], this.selectedAssociates);
  }, ( error ) => {
    this.snackBar.open('Team could not be Un-Archived', '', {
      duration: 3000
    });
  });

 }

  removeAssociate(index) {
   this.selectedAssociates.splice(index , 1);
   this.team.members.associates = Object.assign([], this.selectedAssociates);
   // this.update();
  }

  update() {
    this.organizationService.updateTeam(this.organization._id, this.teamId, this.team, this.originalAssociates).subscribe((data) => {
      if ( this.originalTeamLeaderId !== this.team.teamDetail.teamLeader.id  ) {
        this.team.members.associates.forEach(assc => {
          if (assc.id !== this.team.teamDetail.teamLeader.id ) {
          this.notificationService.sendNotification(assc.id,
            `Team leader of the team <b>${this.team.teamDetail.name}</b> has been changed`, 'Organization',
            `home/organization/team-profile/edit/${this.team._id}/${this.organizationId}`);
          }
        });
        this.notificationService.sendNotification(this.team.teamDetail.teamLeader.id,
          `You are now Team Leader of <b>${this.team.teamDetail.name}</b>`, 'Organization',
          `home/organization/team-profile/edit/${this.team._id}/${this.organizationId}`);
      }

    let updateAssociates = [];
    let deleteAssociates = [];
    let addAssociates = [];
    let orignassc = [];
    this.originalAssociates.forEach((assc) => {
        orignassc.push(assc.associateId);
    });

    let newAssc = [];
    this.team.members.associates.forEach((assc) => {
        newAssc.push(assc.id);
    });
    for (var i = 0; i < orignassc.length; i++) {
        for (var j = 0; j < newAssc.length; j++) {
            if (orignassc[i] === newAssc[j]) {
                updateAssociates.push(orignassc[i]);
                orignassc.splice(i, 1);
                newAssc.splice(j, 1);
                i = i - 1;
                j = j - 1;
            }
        }
    }
    addAssociates = newAssc;
    deleteAssociates = orignassc;
    addAssociates.forEach(associateId => {
        // --------------------------------------------
    // sending notifications to associates that have been added and removed from the team
      this.notificationService.sendNotification(associateId,
        `You have been added to <b>${this.team.teamDetail.name}</b> `, 'Organization',
        `home/organization/team-profile/edit/${this.team._id}/${this.organizationId}`);
    });
    deleteAssociates.forEach(associateId => {
      this.notificationService.sendNotification(associateId,
        `You have been removed from <b>${this.team.teamDetail.name}</b>`, 'Organization',
        `home/organization/team-profile/edit/${this.team._id}/${this.organizationId}`);
    });
    // -------------------------------------------
    // send notification to all associates that team has been updated
    this.team.members.associates.forEach(assc => {
      this.notificationService.sendNotification(assc.id,
        `Your Team <b>${this.team.teamDetail.name}</b>'s details have been created`, 'Organization',
        `home/organization/team-profile/edit/${this.team._id}/${this.organizationId}`);
    });

    // send notification to team leader if changed
    if (this.originalTeamLeaderId !== this.team.teamDetail.teamLeader.id) {
      this.notificationService.sendNotification(this.team.teamDetail.teamLeader.id,
        `You have been added to the Team: <b>${this.team.teamDetail.name}</b> `, 'Organization',
        `home/organization/team-profile/edit/${this.team._id}/${this.organizationId}`);
    }
    // send notifications to Opco Leader and HR Leader and HR Teams
    this.notificationService.sendNotification(this.organizationService.hrLeaderId,
      `Team <b>${this.team.teamDetail.name}</b> has been edited`,
          'Organization',  `home/organization/team-profile/edit/${this.team._id}/${this.organizationId}`);
    this.notificationService.sendNotification(this.organizationService.companyLeaderId,
      `Team <b>${this.team.teamDetail.name}</b> has been edited`,
              'Organization',  `home/organization/team-profile/edit/${this.team._id}/${this.organizationId}`);
    this.organizationService.hrTeamIds.forEach(hrId => {
      this.notificationService.sendNotification(hrId,
        `Team <b>${this.team.teamDetail.name}</b> has been edited`,
              'Organization',  `home/organization/team-profile/edit/${this.team._id}/${this.organizationId}`);
    });

    // -----------------------------------------
      this.originalTeamLeaderId = this.team.teamDetail.teamLeader.id;
      this.snackBar.open('Team Updated', '', {
        duration: 3000
      });
      this.originalAssociates = JSON.parse(JSON.stringify(this.selectedAssociates));
    }, ( error ) => {
      console.log(error);
      this.toastService.error(this.errors.Server['501']);
    })
  }
  backBtnClick(){
    this._location.back();
  }

  getServerData(event) {
    this.startMemberIndex = event.pageIndex * event.pageSize;
  }

  sortData(sort: Sort) {
    let data = Object.assign([],this.originalAssociates);
    if (!sort.active || sort.direction === '') {
      this.selectedAssociates = this.originalAssociates;
      return;
    }
    let isAsc = sort.direction === 'asc';
    let sortedList = data.sort((a, b) => {
        switch (sort.active) {
          case 'name': return this.compare(a.name.toLowerCase(), b.name.toLowerCase(), isAsc);
          case 'jobCategory': return this.compare(a.jobCategory.toLowerCase(), b.jobCategory.toLowerCase(), isAsc);
          default: return 0;
        }
    });
    this.selectedAssociates = sortedList;
  }
  
  compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}
